import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IArcadeGameConfiguration, ArcadeGameConfiguration } from './_domain/models/arcade-game';
import HowToPlayComponent from '@/components/arcade-game/_components/how-to-play';

@Component({
  name: 'ArcadeGameComponent',
  components: {
    howToPlay: HowToPlayComponent
  }
})
export default class ArcadeGameComponent extends TombolaBaseComponent {
  @Prop() public gameName: string;
  private arcadeGameConfig: IArcadeGameConfiguration = null;
  private selectedSkin: string = '';
  private selectedBonusRound: string = '';

  private get isSelectedSkinHowToPlay(): boolean {
    return this.selectedSkin === '';
  }

  private get skinsSelections(): any[] {
    const skins: any = this.arcadeGameConfig ? this.arcadeGameConfig.skins.map((skin) => ({ value: skin, text: skin })) : [];
    skins.unshift({ value: '', text: 'How to Play' });
    return skins;
  }

  private get hasBonusRounds(): boolean {
    const bonusRounds = this.getAvailableBonusRounds();
    return bonusRounds.length > 0;
  }

  private get bonusRoundsSelections(): any[] {
    const bonusRounds = this.getAvailableBonusRounds();
    bonusRounds.unshift({ value: '', text: '(Please Select)' });
    return bonusRounds;
  }

  private get videoUrl(): string {
    return [`http://uk-live.s3.amazonaws.com/clients/cms/resources/arcade/1/${this.gameName}`, this.selectedSkin, this.selectedBonusRound].filter(Boolean).join('-') + '.mp4';
  }

  private async mounted() {
    this.arcadeGameConfig = await this.getGameConfiguration();
  }

  protected async getGameConfiguration(): Promise<IArcadeGameConfiguration> {
    const config = await this.configuration();
    return new ArcadeGameConfiguration(this.gameName, config);
  }

  private getAvailableBonusRounds() {
    return this.arcadeGameConfig ? this.arcadeGameConfig.bonusRounds.map((bonus) => ({ value: bonus, text: bonus })) : [];
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/arcade-game.component.ts